import Button from "@/components/Button";
import MeeyImage from "@/components/MeeyImage";
import VideoPlayer from "@/components/VideoPlayer";
import { MediaTypeEnum } from "@/constants/enum/media";
import { ProjectContext } from "@/context/project.context";
import { ListFileProjectReview } from "Models";
import clsx from "clsx";
import { useContext, useState } from "react";
import ModalViewAllFile from "./ModalViewAllFile";
import ModalViewDetailFile from "./ModalViewDetailFile";

const MAX_FILE_SHOW = 4;

const FileMedia = ({ enableShowFull = true, maxFileShow = MAX_FILE_SHOW }) => {
  const {
    projectListFile,
    selectedViewFiles,
    setSelectedViewFiles,
    topFileMedia,
  } = useContext(ProjectContext);
  const [openModalAllFile, setOpenModalAllFile] = useState(false);
  const [openModalDetailFile, setOpenModalDetailFile] = useState(false);

  return (
    <>
      {selectedViewFiles?.currentFile && !openModalAllFile ? (
        <ModalViewDetailFile />
      ) : null}
      {openModalAllFile ? (
        <ModalViewAllFile
          openModal={openModalAllFile}
          setOpenModalAllFile={setOpenModalAllFile}
          openModalDetail={openModalDetailFile}
          setOpenModalDetail={setOpenModalDetailFile}
        />
      ) : null}
      {topFileMedia?.length ? (
        <div className="bg-white rounded-lg p-3 shadow-light-1">
          <span className="text-grey-500 text-fs-14 font-medium">
            FILE PHƯƠNG TIỆN
          </span>
          <hr className="my-3" />
          <div className="grid grid-cols-2 gap-3">
            {topFileMedia
              ?.slice(0, maxFileShow)
              ?.map((file: ListFileProjectReview) => {
                return (
                  <div
                    key={file._id}
                    onClick={() => {
                      if (enableShowFull) {
                        setSelectedViewFiles({
                          currentFile: file,
                          files: projectListFile?.results,
                        });
                        setOpenModalDetailFile(true);
                      }
                    }}
                    className={clsx(
                      "relative group cursor-pointer",
                      file.mediaType == MediaTypeEnum.IMAGE.toString() ||
                        file.mediaType == MediaTypeEnum.VIDEO.toString()
                        ? "can-preview-upload"
                        : "default-file"
                    )}
                    // onClick={preview}
                  >
                    {file.mediaType == MediaTypeEnum.IMAGE.toString() ? (
                      <div className="w-[138px] h-[138px] bg-grey-200 rounded-md flex flex-col relative cursor-pointer">
                        <div className="  text-fs-12 w-full h-full overflow-hidden  rounded">
                          <MeeyImage
                            className="object-cover w-full h-full"
                            src={file.uri}
                            alt={file.name}
                            resizeOnFly={!!file?.uri}
                            resizeOptions={{
                              width: 138,
                              height: 138,
                            }}
                          />
                        </div>
                      </div>
                    ) : file.mediaType == MediaTypeEnum.VIDEO.toString() ? (
                      <div className="w-[138px] h-[138px] bg-grey-200 rounded-md flex flex-col relative cursor-pointer">
                        <div className="text-fs-12 w-full h-full overflow-hidden  rounded-md">
                          {/* <video
                            src={file.url}
                            className="h-full w-full object-cover"
                          /> */}
                          <VideoPlayer
                            options={{
                              autoplay: false,
                              controls: false,
                              responsive: true,
                              fluid: true,
                              preload: "metadata",
                              sources: [
                                {
                                  src: file.urlVod,
                                },
                              ],
                            }}
                          />
                          <div className="absolute top-1/2 left-1/2  -translate-y-1/2 -translate-x-1/2">
                            <i className="mrv mrv-play_arrow text-white text-fs-28 font-bold"></i>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="w-[138px] h-[138px] bg-grey-200 rounded-md flex flex-col gap-[66px] relative cursor-pointer border border-transparent border-dashed">
                        <div className="flex-[0_0_24px] w-full flex items-end pt-1">
                          <i className="mrv mrv-attach_file text-fs-24 leading-6"></i>
                          <div className="text-fs-12">
                            .{file?.name?.split(".")?.pop()}
                          </div>
                        </div>
                        <div className="bg-grey-300 flex-[1_1_auto]  text-fs-12 py-1.5 px-2 overflow-hidden  rounded-b-md break-all">
                          <span className="line-clamp-2">{file.name}</span>
                        </div>
                      </div>
                    )}
                    <div className="cursor-pointer absolute w-full h-full top-0 z-10 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100  rounded-md duration-300">
                      <i className="mrv mrv-preview text-white text-fs-28"></i>
                    </div>
                  </div>
                );
              })}
          </div>
          {topFileMedia?.length > 4 ? (
            <Button
              className="meey-button meey-button-grey meey-button-filled rounded-md text-fs-16 font-semibold py-2.5 px-4 h-11 flex justify-center items-center w-full mt-3"
              onClick={() => {
                setOpenModalAllFile(true);
                setSelectedViewFiles({
                  currentFile: null,
                  files: projectListFile?.results,
                });
              }}>
              Xem thêm
            </Button>
          ) : null}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default FileMedia;
